export default "__VITE_ASSET__14828cd7__"